export default __webpack_public_path__ + "static/income_tax-09b7b2afd8bb02966a0f553f38d7bae8.png";